import React, { FC } from 'react';

import styled from 'styled-components';

import Button from '@components/Button';
import { Modal, ModalApi } from '@components/Modal';
import { Separator } from '@components/formStyles';
import CustomIcon from '@components/utils/CustomIcon';
import { Delete } from '@assets/icons';

const Content = styled.p`
  margin: 0px 0 0;
  font-size: 16px;
  line-height: 1.56;
  color: ${(p) => p.theme.palette.darkGray};
  @media (max-width: 767px) {
    text-align: justify;
  }
  ${(p) => p.theme.mediaQueries.SMALL} {
    text-align: left;
  }
`;

const Title = styled.h2`
  font-family: ${({ theme }) => theme.fonts.main};
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

const Description = styled.span`
  opacity: 0.75;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

const StyledButton = styled(Button)`
  width: 250px;
  height: 60px !important;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    align-items: center;
    margin-top: 80px;

    & > button {
      margin-bottom: 20px;
    }
  }
`;

const Div = styled.div`
  display: flex;
  justify-content: center;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    align-items: center;
    margin-top: 80px;
  }
`;

const defaultContentRenderer = (content: React.ReactNode) => (
  <Content>
    <Description>{content}</Description>
  </Content>
);

const ConfirmationModal: FC<{
  title?: string;
  content: React.ReactNode;
  onCancel?(): void;
  onSubmit?(): void;
  cancelButtonText?: string;
  actionButtonText?: string;
  isConfirmLoading?: boolean;
  isConfirmDisabled?: boolean;
  renderContent?: typeof defaultContentRenderer;
}> = ({
  title = '',
  content,
  onCancel,
  onSubmit,
  isConfirmLoading = false,
  isConfirmDisabled = false,
  cancelButtonText = 'Vazgeç',
  actionButtonText = 'Sil',
  renderContent = defaultContentRenderer,
  ...rest
}) => {
  return (
    <Modal
      title={
        title ? (
          <Div>
            <Title>
              <CustomIcon
                paletteColor='primaryBrand'
                icon={Delete}
                fontSize={36}
              />
            </Title>
          </Div>
        ) : null
      }
      isVisible={true}
      onCancel={onCancel}
      width={600}
      maskClosable={isConfirmLoading ? false : true}
      closeable={isConfirmLoading ? false : true}
      {...rest}
    >
      <Separator size='20px' />
      <Div>{renderContent?.(content)}</Div>
      <Separator size='20px' />

      <ButtonsWrapper>
        <StyledButton outline onClick={onCancel} disabled={isConfirmLoading}>
          {cancelButtonText}
        </StyledButton>
        <StyledButton
          loading={isConfirmLoading}
          disabled={isConfirmDisabled}
          onClick={onSubmit}
        >
          {actionButtonText}
        </StyledButton>
      </ButtonsWrapper>
    </Modal>
  );
};

export default ConfirmationModal;

export type { ModalApi };
